// extracted by mini-css-extract-plugin
export default {"container":"ChooseVariante_container__5VnWi","bottomContainer":"ChooseVariante_bottomContainer__JTtvR","topWrapper":"ChooseVariante_topWrapper__5odsQ"};